import React, { useEffect, useState } from 'react';
import './LaunchpadUsers.scss';
import { connect } from 'react-redux';
import {
  getLaunchpadUsersActionRequest,
  filterLaunchpadUsersAction,
  sortLaunchpadUsersAction,
  updateQuickFilterAction
} from '../../store/launchpadUser/launchpadUserActions';
import MercurXLaunchpadUserTable 
from '../../components/MercurXLaunchpadUserTable/MercurXLaunchpadUserTable';
import { Col, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { launchpadUsersQuickFilterConstants } from './launchpadUsersConstants';


function LaunchpadUsers({ ...props }) {
  const {
    getlaunchpadUsersRequest,
    launchpadUsers,
    quickFilter,
    updateQuickFilter,
    sortLaunchpadUsers,
    filterLaunchpadUsers,
  } = props;

  const [filterInput, setFilterInput] = useState('');

  useEffect(() => {
    getlaunchpadUsersRequest();
    updateQuickFilter(launchpadUsersQuickFilterConstants.ALL)
  }, []);
  useEffect(() => {
    filterLaunchpadUsers(filterInput);
    sortLaunchpadUsers();
  }, [quickFilter]);

  useEffect(() => {
    filterLaunchpadUsers(filterInput);
    sortLaunchpadUsers();
  }, [filterInput])

  useEffect(() => {
    filterLaunchpadUsers(filterInput);
    sortLaunchpadUsers();
  }, [launchpadUsers]);

  return (
    <>
      <div className="text-fs-head-md mb-4">Launchpad Users</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by full name or email..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <Row
        id="launchpadUsers-container"
        className="d-flex align-items-center justify-content-end mt-4"
      >
        <Col className="text-md-end">
        <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === launchpadUsersQuickFilterConstants.ALL ? 'primary' : 'light'}
              className={
                quickFilter !== launchpadUsersQuickFilterConstants.ALL ? 'text-t-body-color' : ''
              }
              id="tbg-radio-1"
              value={launchpadUsersQuickFilterConstants.ALL}
              onClick={() => updateQuickFilter(launchpadUsersQuickFilterConstants.ALL)}
            >
              All
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === launchpadUsersQuickFilterConstants.TRUE ? 
                'primary' : 'light'}
              className={
                quickFilter !== launchpadUsersQuickFilterConstants.TRUE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-2"
              value={launchpadUsersQuickFilterConstants.TRUE}
              onClick={() => updateQuickFilter(launchpadUsersQuickFilterConstants.TRUE)}
            >
              True
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === launchpadUsersQuickFilterConstants.FALSE ? 
                'primary' : 'light'}
              className={
                quickFilter !== launchpadUsersQuickFilterConstants.FALSE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-3"
              value={launchpadUsersQuickFilterConstants.FALSE}
              onClick={() => updateQuickFilter(launchpadUsersQuickFilterConstants.FALSE)}
            >
              False
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <div id="launchpadUsers-container">
        <MercurXLaunchpadUserTable />
      </div>
      
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    launchpadUsers: state.launchpadUserReducer.launchpadUsers,
    quickFilter: state.launchpadUserReducer.quickFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getlaunchpadUsersRequest: (payload) => {
      dispatch(getLaunchpadUsersActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    sortLaunchpadUsers: (payload) => {
      dispatch(sortLaunchpadUsersAction(payload));
    },
    filterLaunchpadUsers: (payload) => {
      dispatch(filterLaunchpadUsersAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LaunchpadUsers);
